import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../../cancel-order/services/cancel-order.service';
import { CancelOrder, CancelOrderGarment } from '../../../cancel-order/models/cancel-order.model';
import { ToasterService } from "../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
    selector: 'app-garment-return-customer-review-page',
    templateUrl: 'garment-return-customer-review.page.html',
    styleUrls: [
      './garment-return-customer-review.page.scss',
    ]
  })
  export class GarmentReturnCustomerReviewPage implements OnInit {

    constructor(
      private router: Router,
      public authService: GtrakAuthService,
      private route: ActivatedRoute,
      private toasterService: ToasterService,
      private cancelOrderService: CancelOrderService,
    ) { }
    customerCode:string="";
    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean=false;
    requestParams:any;
    isShowData:boolean=false;
    currentDate = new Date();
    public viewChange: boolean = false;
    async ngOnInit() {
     this.loaded = true;
     this.loadData();
    }
   async loadData(){
       this.loaded = false;
      this.requestParams = new RequestParams();
         this.customerCode = this.route.snapshot.paramMap.get('id');
      await this.cancelOrderService.getReturnReviewByCustomer(this.customerCode).then((cancelOrder) => {
        this.cancelOrders = cancelOrder;
      });
      for (let i = 0; i < this.cancelOrders.length; i++) {
        let woLossCharge = 0;
        const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
        for (let j = 0; j < cancelOrderGarments.length; j++) {
          if(cancelOrderGarments[j].dateCollected === null) {
            woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            //round to 2 decimal places
            woLossCharge = Math.round(woLossCharge * 100) / 100;
            this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
          }
        }
        this.cancelOrders[i].lossCharge = woLossCharge;
      }

      this.loaded = true;
    }
 getCustomerReport(){
  if(this.customerCode==""){
     this.toasterService.presentToast(
        "danger",
        "Error",
        "Please Enter Customer Code."
      );
    }
    else{
        this.isShowData=true;
        this.loadData();
    }
 }
  changePrinterView(): void {
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000); 
  }
   getActionTypeText(actionType: string): string {
  switch (actionType) {
    case 'S':
      return 'Charged';
    case 'P':
      return 'Planned Remove';
    case 'A':
      return 'Add';
    case 'D':
      return 'Discard';
    default:
      return 'Collected';
  }
}
  }